// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `auto-complete-projects {
  --line-height: 26px;
}
auto-complete-projects .auto-complete {
  resize: vertical;
  width: 100%;
  padding: 0px;
  margin: 0px 0;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background-color: white;
  position: relative;
  min-height: var(--line-height);
}
auto-complete-projects .auto-complete .title {
  padding: 2px;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0);
  color: black;
  display: inline-block;
}
auto-complete-projects .auto-complete .title:hover {
  cursor: pointer;
  background-color: rgba(214, 214, 214, 0.5);
  border: 1px solid rgba(218, 218, 218, 0.7);
}
auto-complete-projects .cdk-virtual-scroll-content-wrapper {
  overflow: hidden;
}
auto-complete-projects .remove-item-icon {
  line-height: 18px;
  padding: 3px;
  vertical-align: middle;
  display: inline-block;
}
auto-complete-projects .remove-item-icon:hover {
  color: rgb(170, 0, 0);
}
auto-complete-projects auto-complete .itemInfo {
  width: 70%;
}
auto-complete-projects auto-complete .itemImage {
  max-width: 100%;
}
auto-complete-projects auto-complete .item {
  height: 68px;
  width: 100%;
  box-sizing: border-box;
  z-index: 2;
}
auto-complete-projects .auto-complete .item {
  z-index: 2;
  position: relative;
  display: inline-block;
}
auto-complete-projects .single-select .remove-item-icon {
  float: right;
}
auto-complete-projects .single-select .item, auto-complete-projects .single-select .title {
  display: block;
  width: 100%;
  box-sizing: border-box;
  opacity: 1;
}
auto-complete-projects .single-select .noItems {
  margin-top: 14px;
}
auto-complete-projects .single-select .queryInput {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  background-color: white;
  margin-bottom: 0px;
  margin-top: 0px;
  height: 30px;
  font-family: Gothic;
  line-height: var(--line-height);
  font-size: 16px;
  padding-left: 5px;
  box-sizing: border-box;
  opacity: 0;
}
auto-complete-projects .single-select .itemList {
  position: absolute;
  top: 20px;
  width: 100%;
  z-index: 2;
  box-sizing: border-box;
  border: 1px solid rgb(14, 14, 14);
  box-shadow: 0 0 5px rgba(50, 50, 50, 0.4), 0 0 1px rgba(20, 20, 20, 0.4);
}
auto-complete-projects .single-select .auto-complete .title {
  color: black;
  width: 100%;
  display: block;
  box-sizing: border-box;
}
auto-complete-projects .single-select.input-focused .title {
  opacity: 0;
  transition: 200ms ease-in;
}
auto-complete-projects .single-select.input-focused .queryInput {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/auto-complete/auto-complete-projects/auto-complete-projects.component.scss"],"names":[],"mappings":"AAAA;EAEI,mBAAA;AAAJ;AAEI;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,0CAAA;EAEA,uBAAA;EACA,kBAAA;EACA,8BAAA;AADR;AAII;EACI,YAAA;EACA,kBAAA;EACA,kCAAA;EACA,YAAA;EACA,qBAAA;AAFR;AAKI;EACI,eAAA;EACA,0CAAA;EACA,0CAAA;AAHR;AAMI;EACI,gBAAA;AAJR;AAOI;EACI,iBAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;AALR;AAQI;EACI,qBAAA;AANR;AASI;EACI,UAAA;AAPR;AAUI;EACI,eAAA;AARR;AAWI;EACI,YAAA;EACA,WAAA;EACA,sBAAA;EACA,UAAA;AATR;AAYI;EACI,UAAA;EACA,kBAAA;EACA,qBAAA;AAVR;AAeQ;EACI,YAAA;AAbZ;AAgBQ;EACI,cAAA;EACA,WAAA;EACA,sBAAA;EACA,UAAA;AAdZ;AAiBQ;EACI,gBAAA;AAfZ;AAkBQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,UAAA;AAhBZ;AAmBQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,sBAAA;EACA,iCAAA;EACA,wEAAA;AAjBZ;AAoBQ;EACI,YAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;AAlBZ;AAuBQ;EACI,UAAA;EACA,yBAAA;AArBZ;AAwBQ;EACI,UAAA;AAtBZ","sourcesContent":["auto-complete-projects {\n    \n    --line-height: 26px;\n\n    .auto-complete {\n        resize: vertical;\n        width: 100%;\n        padding: 0px;\n        margin: 0px 0;\n        border: 1px solid rgba(255, 255, 255, 0.3);\n        // background: rgba(255,255,255,0.03);\n        background-color: white;\n        position: relative;\n        min-height: var(--line-height);\n    }\n    \n    .auto-complete .title {\n        padding: 2px;\n        border-radius: 2px;\n        border: 1px solid rgba(0, 0, 0, 0);\n        color: black;\n        display: inline-block;\n    }\n    \n    .auto-complete .title:hover {\n        cursor: pointer;\n        background-color: rgba(214, 214, 214, 0.5);\n        border: 1px solid rgba(218, 218, 218, 0.7);\n    }\n    \n    .cdk-virtual-scroll-content-wrapper {\n        overflow: hidden;\n    }\n    \n    .remove-item-icon {\n        line-height: 18px;\n        padding: 3px;\n        vertical-align: middle;\n        display: inline-block;\n    }\n    \n    .remove-item-icon:hover {\n        color: rgb(170, 0, 0);\n    }\n    \n    auto-complete .itemInfo {\n        width: 70%;\n    }\n    \n    auto-complete .itemImage {\n        max-width: 100%;\n    }\n    \n    auto-complete .item {\n        height: 68px;\n        width: 100%;\n        box-sizing: border-box;\n        z-index: 2;\n    }\n    \n    .auto-complete .item {\n        z-index: 2;\n        position: relative;\n        display: inline-block;\n    }\n    \n    .single-select {\n        \n        .remove-item-icon {\n            float: right;\n        }\n        \n        .item, .title {\n            display: block;\n            width: 100%;\n            box-sizing: border-box;\n            opacity: 1;\n        }\n        \n        .noItems {\n            margin-top: 14px;\n        }\n\n        .queryInput {\n            position: absolute;\n            top: 0px;\n            left: 0px;\n            width: 100%;\n            background-color: white;\n            margin-bottom: 0px;\n            margin-top: 0px;\n            height: 30px;\n            font-family: Gothic;\n            line-height: var(--line-height);\n            font-size: 16px;\n            padding-left: 5px;\n            box-sizing: border-box;\n            opacity: 0;\n        }\n        \n        .itemList {\n            position: absolute;\n            top: 20px;\n            width: 100%;\n            z-index: 2;\n            box-sizing: border-box;\n            border: 1px solid rgb(14, 14, 14);\n            box-shadow: 0 0 5px rgba(50,50,50,.4), 0 0 1px rgba(20,20,20,.4);\n        }\n        \n        .auto-complete .title {\n            color: black;\n            width: 100%;\n            display: block;\n            box-sizing: border-box;\n        }\n    }\n    \n    .single-select.input-focused {\n        .title {\n            opacity: 0;\n            transition: 200ms ease-in;\n        }\n\n        .queryInput {\n            opacity: 1;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
